import { useTranslation } from 'react-i18next';

const SystemPanel = ({ serverHealth, orgProjects, orgShapeCounts, orgUsers, documents, t: _t, onRefreshHealth }) => {
  const { t } = useTranslation();
  const isHealthy = serverHealth?.healthy;

  return (
    <div>
      <div className="glass" style={{ padding: '1rem 1.5rem', marginBottom: '1.5rem', display: 'flex', alignItems: 'center', gap: '1rem' }}>
        <span className={`health-badge ${isHealthy ? 'healthy' : 'unhealthy'}`}>
          <span className="health-dot" />
          {isHealthy ? 'System Healthy' : 'System Issue'}
        </span>
        <span style={{ flex: 1, fontSize: '0.85rem', color: 'var(--pico-muted-color)' }}>{serverHealth?.message || '—'}</span>
        <button className="admin-tab" onClick={onRefreshHealth}>↻ Refresh</button>
      </div>

      <div className="kpi-grid">
        <div className="kpi-card accent-blue">
          <span className="kpi-label">{t('admin.health.database')}</span>
          <span className="kpi-value kpi-status-value">
            <span className={`system-status-indicator ${serverHealth?.database !== 'healthy' ? 'status-degraded' : ''}`} />
            {serverHealth?.database || '—'}
          </span>
        </div>
        <div className="kpi-card accent-green">
          <span className="kpi-label">{t('admin.health.disk_space')}</span>
          <span className="kpi-value">{serverHealth?.diskSpaceGb != null ? `${serverHealth.diskSpaceGb} GB` : '—'}</span>
        </div>
        <div className="kpi-card accent-amber">
          <span className="kpi-label">{t('admin.health.latency')}</span>
          <span className="kpi-value">{serverHealth?.responseTime != null ? `${serverHealth.responseTime}ms` : '—'}</span>
        </div>
        <div className="kpi-card accent-violet">
          <span className="kpi-label">Version</span>
          <span className="kpi-value" style={{ fontSize: '1.2rem' }}>{serverHealth?.version || '—'}</span>
        </div>
      </div>

      <div className="glass metric-card">
        <h5>{t('home.org_stats')}</h5>
        <div className="vitals-grid">
          <div className="vital-item">
            <span className="vital-label">{t('home.stat_projects')}</span>
            <span className="vital-status ok">{orgProjects.length}</span>
          </div>
          <div className="vital-item">
            <span className="vital-label">{t('admin.stats.annotated_pages')}</span>
            <span className="vital-status">{orgShapeCounts?.pages || 0}</span>
          </div>
          <div className="vital-item">
            <span className="vital-label">{t('admin.tab_users')}</span>
            <span className="vital-status">{orgUsers.length}</span>
          </div>
          <div className="vital-item">
            <span className="vital-label">{t('admin.stats.total_documents')}</span>
            <span className="vital-status">{documents.length}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SystemPanel;
